import { Component } from '@angular/core';
import { AppPermission } from '@app/shared/services/apps/apps.service';

@Component({
  standalone: false,
  selector: 'sbnb-boostly',
  template: `
    <sbnb-apps-detail-page
      vendorCode="boostly"
      name="Boostly"
      logoTile="/assets/images/apps/boostly-logo-full.svg"
      builtBy="Boostly"
      builtByLink="https://boostly.co.uk/"
      [categories]="['Direct Booking']"
      [permissions]="[AppPermission.propertyListingRead, AppPermission.calendarWrite]"
      email="support@boostly.co.uk"
      [beta]="false"
      [helpLink]="{
        href: 'http://boostly.co.uk/call',
        text: 'Book a call with Boostly',
      }"
      [helpArticles]="[
        {
          id: '10404930',
          title: 'Connect Hospitable with Boostly to Create an Integrated Direct Booking Site',
        },
      ]">
      <ng-container description>
        <p>
          Boostly’s integration with Hospitable takes your short-term rental business to the next level. Over 100
          Hospitable hosts have already upgraded to Boostly, and here’s why:
        </p>
        <p>
          Our WordPress websites are custom-built to reflect your brand, offering a professional, scalable solution far
          beyond standard templates. Seamlessly integrated with Hospitable, all your property details, availability, and
          bookings sync in real time, ensuring effortless management.
        </p>
        <p>
          Boostly is trusted by over 2,000 hosts worldwide and is the go-to expert for direct bookings in the short-term
          rental industry. When you join Boostly, you gain access to our comprehensive Tools, Tactics, and Training:
        </p>
        <ul class="list list__looser">
          <li>
            <strong>Tools:</strong>
            Unlock the latest AI-powered features, including the Boostly Clone—your personal AI assistant trained on
            direct booking strategies. You can use it for video or voice calls to discuss tactics and improve your
            business. Your website also comes equipped with a live chatbot, which can be powered manually, by your team,
            or handed over to an AI sales rep to enhance guest communication.
          </li>
          <li>
            <strong>Tactics:</strong>
            Access over 80 hours of CPD-accredited training videos, packed with actionable insights. Our library of
            email and social media templates lets you copy, paste, personalize, and implement strategies directly within
            your new Boostly CRM—saving you hours of work while maximizing efficiency.
          </li>
          <li>
            <strong>Training:</strong>
            Twice-weekly coaching calls keep you accountable, ensuring you're on track to achieving your direct booking
            goals. Join a supportive community of like-minded hosts to share strategies and insights.
          </li>
        </ul>
        <p>
          When you upgrade to Boostly, you're not just getting a website—you're investing in a complete solution to
          transform your business. Let Boostly help you take control, reduce OTA reliance, and grow your direct bookings
          like never before.
        </p>
      </ng-container>
      <sbnb-image-carousel [images]="['/assets/images/apps/boostly/boostly-1.png']"></sbnb-image-carousel>
    </sbnb-apps-detail-page>
  `,
})
export class BoostlyComponent {
  public AppPermission = AppPermission;
}
